<template>
  <div v-show="show" ref="Box" class="bgI">
    <div v-if="!isForgotPwd" class="contentBox">
      <div class="contentBox_leftBox">
        <img :src="zgoModImg" alt="">
        <p style="font-size: 16px;color: #666">
          扫一扫，访问彭祖世家网手机版
        </p>
      </div>
      <div class="contentBox_rightBox">
        <div class="topname">
          <span>通行证登录</span>
          <span class="registerbtn" @click="goregisted">注册</span>
        </div>
        <el-form ref="ruleForm" :model="ruleForm" status-icon :rules="rules" label-width="100px" class="demo-ruleForm">
          <el-form-item prop="phoneNumber" style="margin-bottom: 40px">
            <el-input v-model="ruleForm.phoneNumber" auto-complete="off" placeholder="请输入手机号或账号登录">
              <!--<i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="user" /></i>-->
            </el-input>
          </el-form-item>
          <!--<el-form-item prop="checkCode">-->
          <!--<el-input v-model="ruleForm.checkCode" type="checkCode" placeholder="请确验证码 " class="checkbox">-->
          <!--&lt;!&ndash;<i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="pwd" /></i>&ndash;&gt;-->
          <!--</el-input>-->
          <!--<div v-show="isVcodeBtn" class="getVcodeBtn" @click="getVcode">-->
          <!--获取验证码-->
          <!--</div>-->
          <!--<div v-show="!isVcodeBtn" class="getVcodeBtn num">-->
          <!--重新发送 <span>({{ count }})</span>-->
          <!--</div>-->
          <!--</el-form-item>-->
          <el-form-item prop="password" :error="modelerror">
            <el-input v-model.number="ruleForm.password" type="password" placeholder="请输入密码 ">
              <!--<i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="pwd" /></i>-->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="denglubtn" @click="submitForm('ruleForm')">
              登录
            </el-button>
            <!--<el-button @click="resetForm('ruleForm')">-->
            <!--重置-->
            <!--</el-button>-->
          </el-form-item>
        </el-form>
        <!--<div class="forgotpwd" @click="changeContent">-->
        <!--忘记密码?-->
        <!--</div>-->
        <!--<div class="register">-->
        <!--还没账号？<span @click="goregisted">立即注册</span>-->
        <!--</div>-->
        <div class="wxlogin">
          <a :href="wxurl" @click="canback"><span class="wxlogo"><svg-icon icon-class="wx" /></span><span>微信登录</span></a>
          <!--<div>-->
          <!--<p @click="handelWxLogin">-->
          <!--<a :href="wxurl"></a>-->
          <!--</p>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <forGotPwd v-show="isForgotPwd" />
    <el-dialog
      title="绑定微信"
      :visible.sync="bindWxFlag"
      width="35%"
      :before-close="handleClose"
      :close-on-click-modal="handelmodal"
      append-to-body
    >
      <p>为了提供更好的用户体验，您的账号需要绑定微信才可以继续使用，去绑定吗？</p>
      <div style="text-align: right;margin-top: 20px">
        <a href="javascript:location.reload();" class="dialog_btn">暂不登录</a>
        <span class="dialog_btn dialog_btn_new" @click="bindWx">绑定微信</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cheakLogin, checkRegister, getVcode, getUserPhoneRegisterUrl } from '@/api/api.js'
import { getWxLoginUrl, addWeiXinUserUrl } from '@/api/login.js'
import forGotPwd from '@/components/forgotpassword/index.vue'
// import topHead from '@/views/components/header.vue'
export default {
  components: { forGotPwd },
  data() {
    var checkpass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var checkvcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入账号'))
      } else {
        callback()
      }
      setTimeout(() => {
        if (!(/^1[345789]\d{9}$/.test(value))) {
          callback(new Error('格式错误，请输入正确的手机号'))
        } else {
          callback()
        }
      }, 500)
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value + '' !== this.ruleForm.password + '') {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      fmsCode: require('@/static/familyspaceCode.png'),
      puyueCode: require('@/static/readerCode.png'),
      modelerror: '',
      handelmodal: false,
      bindWxFlag: false,
      zgoModImg: require('@/static/pengcode.png'),
      logo_txz: require('@/static/logo_txz.jpg'),
      wxurl: '',
      loginIMG: require('@/static/bg_txz.png'),
      show: false,
      isForgotPwd: false,
      isVcodeBtn: true,
      count: 60,
      ruleForm: {
        phoneNumber: '',
        checkCode: '',
        password: ''
      },
      rules: {
        phoneNumber: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        password: [
          { validator: checkpass, trigger: 'blur' }
        ],
        checkCode: [
          { validator: checkvcode, trigger: 'blur' }
        ]
      }
    }
  },
  inject: ['reload'],
  mounted() {
    this.handelWxLogin()
    // var h = document.documentElement.clientHeight || document.body.clientHeight
    // var h = window.outerHeight
    // this.$refs.Box.style.height = h - 391 + 'px'
    const that = this
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which
      if (keycode == 13) {
        that.submitForm('ruleForm')
        return false
      }
    }
    this.show = true
    this.$emit('footshow', 8)
  },
  methods: {
    submitForm(formName) { // //登录验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {}
          obj.userName = this.ruleForm.phoneNumber
          obj.passWord = this.ruleForm.password
          cheakLogin(obj).then(res => {
            if (res.code === 200) {
              if (res.data.isBding) {
                this.setloca('username', this.ruleForm.phoneNumber, 7200)
                this.setloca('userid', res.data.fwUserId, 7200)
                this.setloca('readerUsrId', res.data.readerUsrId, 7200)
                console.log(window.history.length)
                // if (window.history.length >= 2) {
                //   this.$router.go(-1)
                // } else {
                //   this.$router.push('/home')
                // }
                location.reload()
              } else {
                this.bindWxFlag = true
              }
            } else if (res.code == 425) {
              this.modelerror = '密码错误'
              // ////手动报错，密码错误
              // this.rules.password[0].validator = (rule, value, callback) => {
              //   callback(new Error('密码错误'))
              // }
            }
          })
          // checkRegister(obj).then(res => {
          //   if (res.data.code == 0) {
          //     this.setloca('username', this.ruleForm.phoneNumber, 7200)
          //     this.setloca('userid', res.data.fwUserId, 7200)
          //     this.setloca('readerUsrId', res.data.readerUsrId, 7200)
          //     this.$router.go(-1)
          //     this.$router.push({ path: '/home' })
          //   }
          //   if (res.data.code == 1) {
          //     this.setloca('loginphone', res.data.phone, 7200)
          //     var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
          //     if (is_mobi) {
          //       getUserPhoneRegisterUrl({ loginType: 'app' }).then(res => {
          //         window.open(res.data.url)
          //       })
          //     } else {
          //       getUserPhoneRegisterUrl().then(res => {
          //         window.open(res.data.url)
          //       })
          //     }
          //   }
          //   if (res.data.code == 2 || res.data.code == 3) {
          //     this.$message({
          //       showClose: true,
          //       message: res.data.msg,
          //       type: 'warning'
          //     })
          //   }
          // })
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    goregisted() { // 去注册
      this.$router.replace({ path: '/register' })
    },
    changeContent() { // /忘记密码
      this.isForgotPwd = true
    },
    gologin() { // //去登录
      this.isForgotPwd = false
    },
    handelWxLogin() {
      var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
      if (is_mobi) {
        getWxLoginUrl({ loginType: 'app' }).then(res => {
          this.wxurl = res.data.url
        })
      } else {
        getWxLoginUrl().then(res => {
          this.wxurl = res.data.url
        })
      }
    },
    bindWx() {
      var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
      if (is_mobi) {
        addWeiXinUserUrl({ loginType: 'app' }).then(res => {
          window.open(res.data.url)
        })
      } else {
        addWeiXinUserUrl().then(res => {
          window.open(res.data.url)
        })
      }
    },
    handleClose() {
      this.bindWxFlag = false
    },
    getVcode() {
      this.ruleForm.checkCode = ''
      if (!(/^1[34578]\d{9}$/.test(this.ruleForm.phoneNumber))) {
        this.$message({
          message: '请正确输入手机号',
          type: 'error',
          duration: 2000
        })
      } else {
        var obj = {}
        obj.phone = this.ruleForm.phoneNumber
        obj.codeType = '1'
        this.isVcodeBtn = false
        var timers = setInterval(() => {
          this.count--
          if (this.count <= 0) {
            this.isVcodeBtn = true
            clearInterval(timers)
          }
        }, 1000)
        getVcode(obj).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '短信验证已发送',
              type: 'success',
              duration: 2000
            })
          }
        })
      }
    },
    canback() {
      this.setloca('isback', window.location.href, 7200)
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .puyue{
        position: relative
    }
    .fms{
        position: relative;
    }
    .bgI .puyueCode{
        width: 179px;
        /*height: 213px;*/
        position: absolute;
        top: 32px;
        left: -63px;
        z-index: 99;
        transition: 0.3s;
        height: 0;
    }
    .puyue:hover >.puyueCode{
        height: 213px;
    }
    .bgI .fmsCode{
        width: 179px;
        /*height: 213px;*/
        position: absolute;
        top: 32px;
        left: -41px;
        z-index: 99;
        transition: 0.3s;
        height: 0;
    }
    .fms:hover >.fmsCode{
        height: 213px;
    }
    .dialog_btn{
        display: inline-block;
        width: 130px;
        text-align: center;
        height: 40px;
        line-height: 40px;
        border: 1px solid #E6E6E6;
        color: #ccc;
    }
    .dialog_btn_new{
        background-color: #FF7214;
        color: #ffffff;
        border: 1px solid #FF7214;
        margin-left: 20px;
        cursor: pointer;
    }
    .bgI{
        width: 100%;
        position: relative;
        overflow: hidden;
        img{
            width: 100%;
        }
        .loginBgBox{
            position: absolute;
            width: 100%;
            height: 615px;
            overflow: hidden;
            z-index: -1;
        }
        .contentBox{
            margin: 0 auto;
            height: 415px;
            width: 800px;
            padding-top: 35px;
            background-color: #fff;
            overflow: hidden;
            .topname{
                margin: 40px auto;
                margin-top: 0;
                /*margin-top: 20px;*/
                overflow: hidden;
                text-align: center;
                .registerbtn{
                    border: none;
                    cursor: pointer;
                }
                span{
                    display: inline-block;
                    width: 100px;
                    height: 50px;
                    font-size: 17px;
                    line-height: 50px;
                    margin-left: 10px;
                    border-bottom: 2px solid #ed4040;
                }
            }

        }
    }
    .ico{
        height: 40px;
        width: 30px;
        color: #69513c;
    }
    .denglubtn{
        margin-top: 40px;
        width: 320px;
        margin-left: 23px;
        background-color: #7E6B5A;
        border-color: #7E6B5A;
    }
    .forgotpwd{
        color: #808080;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
        &:hover{
            color: #ed4040;
        }
    }
    .register{
        text-align: center;
        font-size: 12px;
        color: #808080;
        margin-top: 15px;
        span{
            font-size: 12px;
            color: #ed4040;
            cursor: pointer;
        }
    }
    .wxlogin{
        text-align: center;
        margin-top: 30px;
        a{
            display: inline-block;
            overflow: hidden;
        }
        span{
            font-size: 12px;
            color: #BCBCBC;
            margin-left: 10px;
        }
        .wxlogo{
            display: inline-block;
            border-radius: 50%;
            border: 1px solid #DFDFDF;
            text-align: center;
            height: 35px;
            width: 35px;
            line-height: 40px;
            cursor: pointer;
            margin-left: 0;
            color: #00bb00;
            svg{
                width: 20px;
                height: 20px;
                color: #00bb00;
            }
        }
        p{
            display: inline-block;
            font-size: 12px;
            color:#bcbcbc;
            margin-top: 5px;
            cursor: pointer;
        }
    }
    .checkbox{
        width: 210px;
    }
    .getVcodeBtn{
        width: 100px;
        display: inline-block;
        background-color: #ed4040;
        margin-left: 10px;
        border-radius: 5px;
        text-align: center;
        color: #ffffff;
        font-size: 12px;
        cursor: pointer;
    }
    .foot_login{
        overflow: hidden;
        text-align: center;
        margin-top: 50px;
        .foot_login_lis{
            display: inline-block;
            height: 30px;
            line-height: 30px;
            a{
                font-size: 14px;
                color: #877463;
                &:hover{
                    color: #ed4040;
                }
            }
            span{
                font-size: 14px;
                margin: 0 10px;
                color: #877463;
            }
        }
    }
    .foo_tips{
        text-align: center;
        font-size: 14px;
        color: #9EA0A3;
        height: 50px;
        background-color: #3F464E;
        padding: 15px 0;
    }
    .head-contents-txz {
        position:fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 90px;
        background: #fff;
        box-shadow: 0 0px 5px 0px hsla(0,0%,72%,.5);
    }
    .nav-txz{
        width: 1200px;
        height: 90px;
        margin: 0 auto;
    }
    .nav-txz .logo {
        width:296px;
        height: 57px;
        float: left;
        margin: 15px 0 0 0;
    }
    .nav-txz .nav {
        width: 70%;
        text-align: right;
        float: right;
    }
    .nav-txz .nav a {
        line-height: 90px;
        font-size: 16px;
        padding:15px;
        text-decoration: none;
        color: #5C5C5C;
    }
    .nav-txz .nav a:hover {
        color: #e3003a;
    }
    .contentBox_rightBox{
        display: inline-block;
        width: 460px;
        border-left: 1px solid #EEEEEE;
        height: 380px;
        vertical-align: top;
    }
    .contentBox_leftBox{
        display: inline-block;
        vertical-align: top;
        width: 339px;
        margin: 50px auto;
        text-align: center;
        img{
            width: 200px;
            height: 200px;
        }
    }
    .num{
        background-color: #fff;
        color: #a19d9e;
        cursor: not-allowed;
        span{
            font-size: 12px;
            color: #a19d9e;
        }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
        .bgI{
            .contentBox{
                width: 80%;
                margin: 80px auto;
                .denglubtn{
                    width: calc( 80vw - 40px );
                    margin-left: 0;
                }
            }
        }
        .contentBox_leftBox{
            display: none;
        }
        .contentBox_rightBox{
            width: auto;
        }
    }
</style>

